module.exports = __webpack_public_path__ + "static/img/7-bg.1389fd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/7-bg.png
// module id = L4NZ
// module chunks = 0